import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { healthPackages } from "../Data/healthPack";
import { servicesData } from "../Data/serviceData";
import Navbar from "../Navbar/Navbar";
import emailjs from "emailjs-com";
import "./HealthPackageDetails.css";

function HealthPackageDetails() {
  const { name } = useParams();
  const navigate = useNavigate();
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const formRef = useRef();

  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    user_position: "",
  });

  const decodedName = decodeURIComponent(name);
  const packageItem = healthPackages.find((pkg) => pkg.title === decodedName);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (packageItem) {
      setFormData((prev) => ({ ...prev, user_position: packageItem.title }));
    }
  }, [packageItem]);

  if (!packageItem) {
    return <p>Package not found</p>;
  }

  const getServiceDetails = (serviceName) => {
    return servicesData.find((service) => service.name === serviceName);
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(index === activeAccordion ? null : index);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mtn05ga",
        "template_s01htbp",
        formRef.current,
        "egxcYC6EeJdXDm0et"
      )
      .then(() => {
        setIsSubmitted(true);
        setTimeout(() => {
          setIsSubmitted(false);
          setFormData({
            user_name: "",
            user_phone: "",
            user_position: packageItem.title,
          });
          setShowModal(false);
        }, 3000);
      })
      .catch((err) => {
        console.error("EmailJS Error:", err);
        alert("Failed to send booking. Please try again.");
      });
  };

  return (
    <>
      <Navbar />
      <section className="healthpackage-details">
        <div className="container">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title pack-title">{packageItem.subtitle}</h5>
              <h6 className="text-center text-muted">"{packageItem.moto}"</h6>
              <p className="text-center">({packageItem.category})</p>
              {/* <h5 className="card-text pack-price">
                            Price: <span className='text-danger text-decoration-line-through'>₹{packageItem.oldPrice}</span> → 
                            <span className='text-primary ms-2'>₹{packageItem.newPrice}</span>
                        </h5> */}

              <button
                className="btn btn-success my-3"
                onClick={() => setShowModal(true)}
              >
                Book Now
              </button>
              <button
                className="btn btn-primary ms-1"
                onClick={() => navigate(-1)}
              >
                Go Back
              </button>
              <h6>Services Included:</h6>
              <table className="table h-pack d-none d-md-table">
                <thead>
                  <tr>
                    <th className="text-center">Service Name</th>
                    <th>Image</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {packageItem.services.map((serviceName, index) => {
                    const service = getServiceDetails(serviceName);
                    return service ? (
                      <tr key={index}>
                        <td className="fw-bold text-center">{service.name}</td>
                        <td>
                          <img
                            src={service.image}
                            alt={service.name}
                            style={{ width: "50px" }}
                          />
                        </td>
                        <td>{service.description}</td>
                      </tr>
                    ) : (
                      <tr key={index}>
                        <td>{serviceName}</td>
                        <td>Details not found</td>
                        <td>N/A</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className="accordion d-md-none">
                {packageItem.services.map((serviceName, index) => {
                  const service = getServiceDetails(serviceName);
                  return (
                    <div key={index} className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button ${
                            activeAccordion === index ? "" : "collapsed"
                          }`}
                          type="button"
                          onClick={() => toggleAccordion(index)}
                        >
                          {service ? service.name : serviceName}
                        </button>
                      </h2>
                      <div
                        className={`accordion-collapse collapse ${
                          activeAccordion === index ? "show" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          {service ? service.description : "Details not found"}
                          {service && (
                            <img
                              src={service.image}
                              alt={service.name}
                              style={{ width: "100px", marginTop: "10px" }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="instructions mt-5">
                <h6 className="text-center fs-3">Important Instructions</h6>
                <ul>
                  <li>Please take prior appointments.</li>
                  <li>
                    For appointments, Call: 9238008811, 7608005555, 7894005555.
                  </li>
                  <li>
                    Report at Health check-up desk at 8am on an empty stomach.
                  </li>
                  <li>
                    Women should inform regarding pregnancy status as X-Ray/CT
                    should be avoided.
                  </li>
                  <li>
                    Check-up takes ~4-5 hours. Breakfast provided by hospital.
                  </li>
                  <li>Bring earlier medical reports, if any.</li>
                  <li>
                    Additional tests/consults not included will be charged
                    extra.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div style={{backgroundColor:"rgba(0,0,0,0.5)"}} className="modal show d-block " tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Book {formData.user_position || "Package"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {isSubmitted ? (
                  <div className="text-center">
                    <span style={{ fontSize: "2rem" }}>🎉</span>
                    <h4>Booking Successful!</h4>
                  </div>
                ) : (
                  <form ref={formRef} onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <input
                        type="text"
                        name="user_name"
                        placeholder="Your Name"
                        value={formData.user_name}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="tel"
                        name="user_phone"
                        placeholder="Contact Number"
                        value={formData.user_phone}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="text"
                        name="user_position"
                        value={formData.user_position}
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-success me-2">
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HealthPackageDetails;
